<template>
    <el-select :multiple="multiple" :clearable="clearable" :value="value"  collapse-tags :value-key="type=='object'?'dicCode':''"  @visible-change="visiblechange"  @change="change" :size="size" :placeholder="placeholder" >
        <el-option
                v-for="item,index in list"
                :key="item.dicCode"
                :label="item.dicName"
                :value="type=='object'?item:item.dicCode">
        </el-option>
    </el-select>
</template>

<script>
    export default {
        name: "order-confirm-state",
        props:{
            size:String,
            placeholder:String,
            multiple:Boolean,
            clearable:Boolean,
            value:[Array,Object,String],
            type:String
        },
        model:{
            prop:'value'
        },
        data(){
            return{
                list:[],
            }
        },
        watch:{
            value(newval,oldval){
                var code=this.type=='object'?newval.dicCode:newval;
                var list=this.list.filter((item)=>item.dicCode==code);
                //数据不存在时
                if(list.length==0){
                    this.$store.state.dicChange=true;
                    this.getData();
                }

            }
        },
        mounted(){
            this.getData();
        },
        methods:{
            getData(){
                if(this.$root.getStorage('dic')){
                    this.list=this.$root.getStorage('dic').filter((item)=>item.dicType=='order_confirm_state');
                }else{
                    this.$store.state.dicChange=true;
                }
            },
            // getData(){
            //     this.$axios.post("/dic/orderConfirmStateCode",{
            //         "parentId": "1001",
            //         "dicType": " OrderConfirmState "
            //     }).then(res=>{
            //         // console.log('订单确认状态',res.data.list)
            //         this.list=res.data.list;
            //     }).catch(err=>{
            //         this.$message.error(err.msg);
            //     })
            // },
            visiblechange(isshow){
                if(isshow){
                    // this.getData();
                }
            },
            change(value){
                console.log(value)
                this.$emit('input',value)
            }
        }
    }
</script>

<style scoped>

</style>